import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PredesEditSimpleDialog from './PredesEditSimpleDialog';

class PredesTransactionsEdit extends Component {
  render() {
    return (
      <div>
        <PredesEditSimpleDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

PredesTransactionsEdit.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default PredesTransactionsEdit;
